import { useTranslation } from "react-i18next";

export default function TuitionSection() {
  const { t } = useTranslation();

  return (
    <section id="tuition" className="py-24 bg-gradient-to-b from-teal-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-bold text-center text-gray-900 mb-16">
          {t("tuition_title")}
        </h2>
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-teal-500">
          <div className="bg-gradient-to-r from-teal-600 to-teal-700 p-12 text-center">
            <p className="text-2xl text-white font-medium">
              {t("tuition_contact_message")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
